import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'sortArray'
})
export class SortArrayPipe implements PipeTransform {

    transform(value: any[], arg1?: string, arg2?: string): any[] {
        return value.sort((n1, n2) => {
            if (arg1 && arg2)
                return n1[arg1][arg2]-n2[arg1][arg2]
            else
                return  n1[arg1!]-n2[arg1!]
        });
    }
}